var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c(
        "div",
        { staticClass: "top", attrs: { id: "top" } },
        [
          _c("div", { staticClass: "hello" }, [
            false && _vm.currentUser && _vm.currentUser.staff
              ? _c(
                  "div",
                  { staticClass: "top--search-box" },
                  [
                    _c("search-box", {
                      on: {
                        "search-click": function($event) {
                          return _vm.showSearchModal(false)
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("img", { attrs: { src: "/HELLO.svg", alt: "HELLO" } })
          ]),
          _vm._v(" "),
          _vm.friendRequest.length
            ? _c(
                "div",
                { staticClass: "friend-request" },
                [
                  _c("friend-request", {
                    attrs: { "friend-request": _vm.friendRequest },
                    on: { "open-friend-list": _vm.openFriendRequests }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.showFriendRequest && _vm.friendRequest.length
            ? _c(
                "div",
                { staticClass: "friend-request-item" },
                [
                  _c("friend-request-item", {
                    attrs: { "friend-request": _vm.friendRequest },
                    on: {
                      "open-friend-list": _vm.openFriendRequests,
                      "delete-friend-request": _vm.deleteMemberFriendRequest,
                      "accept-friend-request": _vm.acceptMemberFriendRequest
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.currentUser
            ? _c(
                "div",
                { staticClass: "school-list" },
                [
                  _c("school-list", {
                    attrs: { "current-user": _vm.currentUser }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "swiper",
            {
              ref: "slider-sp",
              staticClass: "slider-sp",
              style: {
                "--swiper-pagination-color": "#6dbbfe",
                "--swiper-navigation-color": "#6dbbfe"
              },
              attrs: { options: _vm.swiperOptionSP }
            },
            [
              _vm._l(_vm.followings, function(f) {
                return [
                  _c(
                    "swiper-slide",
                    {
                      key: f.id,
                      class: {
                        "single-swiper": _vm.followings.length == 1,
                        "double-swiper": _vm.followings.length >= 2
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "following-members" },
                        [
                          _c("following-member", {
                            key: f.id,
                            staticClass: "following-members--item",
                            attrs: {
                              "current-user": _vm.currentUser,
                              following: f
                            },
                            on: {
                              "member-click": _vm.showMemberProfile,
                              "action-button-click": _vm.startChatWith
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ]
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "swiper-pagination",
                attrs: { slot: "pagination" },
                slot: "pagination"
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "swiper-button-prev",
                attrs: { slot: "button-prev" },
                slot: "button-prev"
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "swiper-button-next",
                attrs: { slot: "button-next" },
                slot: "button-next"
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "swiper",
            {
              ref: "slider-pc",
              staticClass: "slider-pc",
              style: {
                "--swiper-pagination-color": "#6dbbfe",
                "--swiper-navigation-color": "#6dbbfe"
              },
              attrs: { options: _vm.swiperOption }
            },
            [
              _vm._l(_vm.followingsSliced, function(parent, parentIndex) {
                return [
                  _c("swiper-slide", { key: parentIndex }, [
                    _c(
                      "div",
                      { key: parentIndex, staticClass: "following-members" },
                      [
                        _vm._l(_vm.followingsSliced[parentIndex], function(
                          f,
                          index
                        ) {
                          return [
                            _c("following-member", {
                              key: f.id,
                              staticClass: "following-members--item",
                              style: [
                                index <
                                  _vm.followingsSliced[parentIndex].length / 2 -
                                    1 &&
                                _vm.followingsSliced[parentIndex].length % 2 ==
                                  1 &&
                                _vm.followingsSliced[parentIndex].length > 3
                                  ? index == 0
                                    ? {
                                        display: "flex",
                                        "justify-content": "flex-start",
                                        "--divisor":
                                          _vm.followingsSliced[parentIndex]
                                            .length /
                                            2 -
                                          1 +
                                          ((_vm.followingsSliced[parentIndex]
                                            .length /
                                            2 -
                                            1) %
                                            1)
                                      }
                                    : index ==
                                      _vm.followingsSliced[parentIndex].length /
                                        2 -
                                        1 -
                                        ((_vm.followingsSliced[parentIndex]
                                          .length /
                                          2 -
                                          1) %
                                          1)
                                    ? {
                                        display: "flex",
                                        "justify-content": "flex-end",
                                        "--divisor":
                                          _vm.followingsSliced[parentIndex]
                                            .length /
                                            2 -
                                          1 +
                                          ((_vm.followingsSliced[parentIndex]
                                            .length /
                                            2 -
                                            1) %
                                            1)
                                      }
                                    : {
                                        "--divisor":
                                          _vm.followingsSliced[parentIndex]
                                            .length /
                                            2 +
                                          1 -
                                          ((_vm.followingsSliced[parentIndex]
                                            .length /
                                            2) %
                                            1)
                                      }
                                  : {
                                      "--divisor":
                                        _vm.followingsSliced[parentIndex]
                                          .length /
                                          2 +
                                        1 +
                                        ((_vm.followingsSliced[parentIndex]
                                          .length /
                                          2) %
                                          1)
                                    }
                              ],
                              attrs: {
                                "current-user": _vm.currentUser,
                                following: f
                              },
                              on: {
                                "member-click": _vm.showMemberProfile,
                                "action-button-click": _vm.startChatWith
                              }
                            })
                          ]
                        })
                      ],
                      2
                    )
                  ])
                ]
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "swiper-pagination",
                attrs: { slot: "pagination" },
                slot: "pagination"
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "swiper-button-prev",
                attrs: { slot: "button-prev" },
                slot: "button-prev"
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "swiper-button-next",
                attrs: { slot: "button-next" },
                slot: "button-next"
              })
            ],
            2
          ),
          _vm._v(" "),
          _vm.minimizedChatRooms.length
            ? _c(
                "div",
                { staticClass: "minimized-chat-rooms" },
                _vm._l(_vm.minimizedChatRooms, function(room, i) {
                  return _c("minimized-chat-room", {
                    key: i,
                    staticClass: "minimized-chat-rooms--item",
                    attrs: {
                      "current-user": _vm.currentUser,
                      "chat-room": room
                    },
                    on: {
                      click: _vm.openChatRoom,
                      "close-button-click": _vm.removeChatRoom
                    }
                  })
                }),
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("div"),
      _vm._v(" "),
      _c("div", { staticClass: "center-info" }, [
        _c("img", {
          staticClass: "center-info--logo",
          attrs: {
            src: "/your-2nd-community-logo.png",
            alt: "Your 2nd Community"
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "center-info--members" }, [
          _c("div", { staticClass: "center-info--members-count" }, [
            _vm.memberCount > 0
              ? _c("div", [
                  _c("span", { staticClass: "center-info--member-count" }, [
                    _vm._v(_vm._s(_vm.memberCount))
                  ]),
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.communityCount > 0 || _vm.artistCount > 0
                          ? "人のメンバー、"
                          : "メンバーがいます"
                      ) +
                      "\n        "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.communityCount > 0
              ? _c("div", [
                  _c("span", { staticClass: "center-info--member-count" }, [
                    _vm._v(_vm._s(_vm.communityCount))
                  ]),
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.artistCount > 0
                          ? "コミュニティ、"
                          : "コミュニティがあります"
                      ) +
                      "\n        "
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.artistCount > 0
            ? _c("div", [
                _c("span", { staticClass: "center-info--member-count" }, [
                  _vm._v(_vm._s(_vm.artistCount))
                ]),
                _vm._v("\n        人のInstructorがいます\n      ")
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _vm.currentUser && _vm.communityCount
          ? _c(
              "div",
              { staticClass: "center-info--my-list" },
              [
                _c("friend-list", {
                  key: _vm.counterKey,
                  attrs: {
                    onlyFriends: true,
                    isStaff: _vm.currentUser.staff,
                    friendsCount:
                      _vm.communityCount + _vm.memberCount + _vm.artistCount
                  },
                  on: {
                    "friendlist-click": function($event) {
                      return _vm.showSearchModal(true, false, true)
                    },
                    "create-community-click": function($event) {
                      return _vm.showSearchModal(true, true)
                    }
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "customer-support-container" },
          [
            _c("customer-support-members", {
              attrs: {
                "current-user": _vm.currentUser,
                supporters: _vm.supporters.members,
                message: _vm.supporters.message
              },
              on: {
                "member-click": _vm.startChatCustomerSupport,
                "action-button-click": _vm.startChatCustomerSupport,
                "chat-bot-click": _vm.startChatBot
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "online-members-container" }, [
        _c(
          "div",
          { staticClass: "online-members", attrs: { id: "online-members" } },
          _vm._l(
            _vm.followings.filter(function(i) {
              return i.id
            }),
            function(f) {
              return _c("online-member", {
                key: f.id,
                staticClass: "online-members--item",
                attrs: { "current-user": _vm.currentUser, following: f },
                on: { "member-click": _vm.startChatWith }
              })
            }
          ),
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "campaign-banner-container center-panel-image" },
        [
          Math.floor(Date.now() / 1000) <= 1594738800 && false
            ? _c(
                "div",
                {
                  staticClass:
                    "campaign-banner d-none d-sm-none d-md-block d-lg-block"
                },
                [_vm._m(0)]
              )
            : _vm._e(),
          _vm._v(" "),
          Math.floor(Date.now() / 1000) <= 1594738800 && false
            ? _c(
                "div",
                {
                  staticClass:
                    "campaign-banner d-block d-xs-block d-md-none d-lg-none d-xl-none"
                },
                [_vm._m(1)]
              )
            : _vm._e(),
          _vm._v(" "),
          Math.floor(Date.now() / 1000) > 1594738800 && false
            ? _c(
                "div",
                {
                  staticClass:
                    "campaign-banner d-none d-sm-none d-md-block d-lg-block"
                },
                [_vm._m(2)]
              )
            : _vm._e(),
          _vm._v(" "),
          Math.floor(Date.now() / 1000) > 1594738800 && false
            ? _c(
                "div",
                {
                  staticClass:
                    "campaign-banner d-block d-xs-block d-md-none d-lg-none d-xl-none"
                },
                [_vm._m(3)]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.minimizedChatRooms.length
        ? _c(
            "div",
            { staticClass: "minimized-chat-rooms" },
            _vm._l(_vm.minimizedChatRooms, function(room, i) {
              return _c("minimized-chat-room", {
                key: i,
                staticClass: "minimized-chat-rooms--item",
                attrs: { "current-user": _vm.currentUser, "chat-room": room },
                on: {
                  click: _vm.openChatRoomModal,
                  "close-button-click": _vm.removeChatRoom
                }
              })
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "chatbot-container" },
        [
          _vm.currentUser && _vm.showChatbot
            ? _c("chat-bot", {
                ref: "chatBot",
                attrs: { "current-user": _vm.currentUser },
                on: { "member-support-click": _vm.startChatCustomerSupport }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.loading ? _c("loading-modal") : _vm._e(),
      _vm._v(" "),
      _vm.memberProfileModalVisible && _vm.activeMember
        ? _c("member-profile-modal", {
            staticClass: "member-profile",
            attrs: {
              "current-user": _vm.currentUser,
              member: _vm.activeMember
            },
            on: {
              "follow-button-click": _vm.followOrUnfollow,
              "chat-start-button-click": _vm.startChat,
              "close-button-click": _vm.closeMemberProfileModal
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.communityProfileModalVisible && _vm.selectedCommunity
        ? _c("community-profile-modal", {
            staticClass: "member-profile",
            attrs: {
              "current-user": _vm.currentUser,
              community: _vm.selectedCommunity
            },
            on: {
              "follow-button-click": _vm.followOrUnfollow,
              "chat-start-button-click": _vm.startChat,
              "close-button-click": _vm.closeCommunityProfileModal
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.chatRoomVisible
        ? _c("chat-room", {
            ref: "chatRoom",
            attrs: {
              "current-user": _vm.currentUser,
              "default-member": _vm.activeMember,
              "chat-room": _vm.activeChatRoom,
              followings: _vm.followings,
              "polling-func": _vm.loadNewMessages.bind(this),
              "video-limit": _vm.videoDurationLimit,
              chatLoading: _vm.chatLoading
            },
            on: {
              "message-send": _vm.sendMsg,
              "close-button-click": _vm.closeChatRoomModal,
              "reaction-send": _vm.sendRct
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.searchModalVisible && _vm.currentUser
        ? _c("search-modal", {
            attrs: {
              onlyFriends: _vm.onlyFriends,
              isStaff: _vm.isStaff,
              isNormal: _vm.isNormal,
              isCreateCommunity: _vm.isCreateCommunity
            },
            on: { "close-button-click": _vm.closeSearchModal }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.jingleModalVisible
        ? _c("jingle-choice", { attrs: { "current-user": _vm.currentUser } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { attrs: { href: "https://yubista.2nd-community.com" } }, [
      _c("img", {
        staticClass: "campaign-banner-image",
        attrs: {
          src:
            "https://eys-file.s3-ap-northeast-1.amazonaws.com/gate/image/200%25+bnr_pc_sc_top.png"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { attrs: { href: "https://yubista.2nd-community.com" } }, [
      _c("img", {
        staticClass: "campaign-banner-image-small",
        attrs: {
          src:
            "https://eys-file.s3-ap-northeast-1.amazonaws.com/gate/image/200%25+bnr_sp_sc_top.png"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { attrs: { href: "https://yubista.2nd-community.com" } }, [
      _c("img", {
        staticClass: "campaign-banner-image",
        attrs: {
          src:
            "https://eys-file.s3-ap-northeast-1.amazonaws.com/yubista/image/banner/holiday_50_off/bnr_pc_sc_top.png"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { attrs: { href: "https://yubista.2nd-community.com" } }, [
      _c("img", {
        staticClass: "campaign-banner-image-small",
        attrs: {
          src:
            "https://eys-file.s3-ap-northeast-1.amazonaws.com/yubista/image/banner/holiday_50_off/bnr_sp_sc_top.png"
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }